/**
 * Staging deploy config — file-replaces environment.ts for
 * `nx build admin --configuration=staging`. Staging Authentik provider +
 * staging API. The redirect URL must be registered on the
 * `staging-admin-dashboard` Authentik provider.
 */
export const environment = {
  production: false,
  authAuthority: 'https://auth.taketheme.com/application/o/staging-admin-dashboard',
  authClientId: 'axdg1ZwavJRWaTjFy2IbaWOx9J3mQWpS53Qk2jUx',
  authRedirectUrl: 'https://admin.staging-taketheme.dev/auth/callback',
  apiUrl: 'https://api.staging-taketheme.dev',
  // Merchant dashboard origin — target for the impersonation handoff redirect.
  dashboardUrl: 'https://dashboard.staging-taketheme.dev',
  // Public landing site origin — help-center article thumbnails are stored as
  // root-relative paths (e.g. `/help/img/x.jpg`) served by the landing site,
  // not this app, so image columns must resolve them against this origin.
  landingUrl: 'https://staging-taketheme.dev',
}
